import React, { useState } from 'react';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import _ from 'lodash';

import { Section } from 'jbc-front/components/Form';
import { BoxTriple } from 'src/components/Form';
import { isYearFormat } from 'src/utils/CustomValidators';

import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { CustomYearPicker } from './CustomYearPicker';

import TaxCalculationSection from './TaxCalculationSection';

const IncomeTaxAndSSCSection = props => {
  const { dispatch, employeeTaxCalculationSettings } = props;
  const { t } = useTranslation();

  // taxCalculationYear state from available tax calculation settings
  const [taxCalculationYear, setTaxCalculationYear] = useState(Math.max(...Object.keys(employeeTaxCalculationSettings)));

  const isYearEndConfirm = employeeTaxCalculationSettings[taxCalculationYear]?.confirmed;

  const isAvailableDate = currentDate => {
    const datePickerYear = new Date(currentDate).getFullYear();
    // get last year from employeeTaxCalculationSettings, else set to current year
    return Object.keys(employeeTaxCalculationSettings).includes(datePickerYear.toString());
  };

  const updateTaxCalculationYear = e => {
    // get current tax calculation year
    // const taxCalculationYear = moment(e).year();
    const newCalculationYear = moment(e).year();

    setTaxCalculationYear(newCalculationYear);

    // change current tax calculation year data, add default if doesn't exist
    const defaultSetting = {
      isTaxCalculation: false,
      isProvidentFundAllowance: false,
      isSocialSecurityContributionAllowance: false,
      taxOnTaxSetting: 'no_support',
      generalDonationAmount: '0.0',
      residentClassification: 'resident',
      nonResidentTaxSetting: 'twenty_percent_tax',
      dependantNumber: 0,
      abroadIncomeTaxAmount: '0.0',
      year: newCalculationYear
    };

    // try to get current setting, return {} if not found
    const currentSetting = _.get(employeeTaxCalculationSettings, `${newCalculationYear}`, {});
    const mergedSetting = { ...defaultSetting, ...currentSetting };
    // dispatch change with merged setting
    dispatch(change(EMPLOYEE_FORM, `employeeTaxCalculationSettings.${newCalculationYear}`, mergedSetting));
  };

  return (
    <div>
      <BoxTriple>
        <CustomYearPicker
          label={t('features.Employees.components.IncomeTaxAndSSCSection.year')}
          name="taxCalculationYear"
          validate={isYearFormat}
          isValidDate={currentDate => isAvailableDate(currentDate)}
          onChange={year => updateTaxCalculationYear(year)}
          value={taxCalculationYear}
        />
      </BoxTriple>
      <Section title={t('features.Employees.components.IncomeTaxAndSSCSection.tax_calculation')}>
        <TaxCalculationSection isYearEndConfirmed={isYearEndConfirm} taxCalculationYear={taxCalculationYear} />
      </Section>
    </div>
  );
};

const mapStateToProps = state => ({
  employeeTaxCalculationSettings: _.get(getFormValues(EMPLOYEE_FORM)(state), 'employeeTaxCalculationSettings', {})
});

export default connect(mapStateToProps)(IncomeTaxAndSSCSection);
